import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CleanNamePipe } from './clean-name.pipe';
import { TimeFormatPipe } from './time-format.pipe';
@NgModule({
  declarations: [CleanNamePipe, TimeFormatPipe],
  imports: [CommonModule],
  exports: [CleanNamePipe, TimeFormatPipe],
})
export class PipesModule {}
